import { render, staticRenderFns } from "./AppleAddToHomeScreenModal.vue?vue&type=template&id=9b61a7b2&scoped=true&"
import script from "./AppleAddToHomeScreenModal.vue?vue&type=script&lang=js&"
export * from "./AppleAddToHomeScreenModal.vue?vue&type=script&lang=js&"
import style0 from "./AppleAddToHomeScreenModal.vue?vue&type=style&index=0&id=9b61a7b2&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "9b61a7b2",
  null
  
)

export default component.exports